/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { GlobalSearchListComponent } from './global-search-list.component';

@NgModule({
    declarations: [GlobalSearchListComponent],
    imports: [CommonModule, CoreModule],
    exports: [GlobalSearchListComponent],
})
export class GlobalSearchListModule {
}
